import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css'; // Import the custom styles

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
